import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
//perfect scrollbar
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { BfxOrderRecapComponent } from "./bfx-order-recap.component";
import { FormsModule } from "@angular/forms";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};
/* Feature Modules */
//import { ClipboardModule } from 'ngx-clipboard'
@NgModule({
  imports: [
    CommonModule,
    PerfectScrollbarModule, //PERFECT_SCROLLBAR_CONFIG
    FormsModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  declarations: [BfxOrderRecapComponent],
  exports: [BfxOrderRecapComponent],
  bootstrap: [BfxOrderRecapComponent],
})
export class BfxOrderRecapModule {}
